/**
 * Simple wrapper for the vibration API to provide haptic feedback.
 * Works in most browsers and is safely ignored where not supported.
 */
export function haptic(pattern: number | number[] = 10): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(pattern);
    } catch {
      // Ignore vibration errors (e.g. from user gesture requirements)
    }
  }
}

export const Haptics = {
  light: () => haptic(10),
  medium: () => haptic(20),
  heavy: () => haptic([30, 10, 30]),
  success: () => haptic([10, 50, 10]),
  error: () => haptic([50, 100, 50, 100]),
};
